webpackJsonp([152580439225175],{

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValuePagesTemplate = __webpack_require__(74);
	
	var _ValuePagesTemplate2 = _interopRequireDefault(_ValuePagesTemplate);
	
	var _Text = __webpack_require__(55);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PageTitle = __webpack_require__(54);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GrowthPage = function GrowthPage() {
	  return _react2.default.createElement(
	    _ValuePagesTemplate2.default,
	    null,
	    _react2.default.createElement(_PageTitle2.default, { title: 'Growth Opportunities' }),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      'We want to work on projects that we believe give us the opportunity to become better people and better professionals.'
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      'Growth is a choice, not a byproduct.'
	    )
	  );
	};
	
	exports.default = GrowthPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-growth-opportunities-js-08ac58b8af80e3feadf7.js